import type { AnalyticsTabKey } from '~containers/analytics/overview-page/tabs';

export const LEGACY_ANALYTICS_ROUTES: readonly (readonly [
    string,
    AnalyticsTabKey
])[] = [
    ['/analytics/acquisition', 'acquisition'],
    ['/analytics/engagement', 'engagement'],
    ['/analytics/retention', 'retention'],
    ['/analytics/demographic', 'demographic'],
];

/** Drops any `tab` pair from a raw, unparsed query string. Every other pair
 * keeps its order and value untouched. */
function withoutTabParam(query: string): string {
    return query
        .split('&')
        .filter((pair) => pair !== '' && pair.split('=')[0] !== 'tab')
        .join('&');
}

/** `search` is `location.search` (leading `?` optional); its params are kept
 * verbatim, except a `tab` it already carries: the legacy path's own tab
 * always wins. */
export function buildLegacyAnalyticsRedirect(
    legacyPath: string,
    search: string
): string {
    const tab = LEGACY_ANALYTICS_ROUTES.find(
        ([path]) => path === legacyPath
    )?.[1];
    const query = withoutTabParam(search.replace(/^\?/, ''));
    const params = [tab ? `tab=${tab}` : '', query].filter(Boolean);
    return params.length
        ? `/analytics/overview?${params.join('&')}`
        : '/analytics/overview';
}
